<template>
  <div>
    <v-data-table :headers="headers"
                  :loading="loading"
                  :search="search"
                  :items="ftpSubAccounts">
      <template v-slot:item.dir="{ item }">
        <path-info :path="item.dir"></path-info>
      </template>
      <template v-slot:item._diskused="{ item }">
        <v-progress-linear v-if="item.humandiskquota !== 'None'"
                           color="primary"
                           height="26"
                           :value="quotaPercentage(item.diskusedpercent_float)">
          <template v-slot:default="{ value }">
            {{ item.humandiskused }} / {{ item.humandiskquota }}
          </template>
        </v-progress-linear>
        <v-progress-linear v-else
                           color="primary"
                           height="26"
                           value="0">
          <template v-slot:default="{ value }">
            {{ item.humandiskused }} / ∞
          </template>
        </v-progress-linear>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <gg-btn v-on="on" v-bind="attrs">
              Manage
              <v-icon class="ml-1">mdi-chevron-down</v-icon>
            </gg-btn>
          </template>
          <v-list>
            <v-list-item @click="openConfigureModal(item)">
              <v-list-item-title>FTP Information</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openPathModal(item)">
              <v-list-item-title>Change Home Path</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openQuotaModal(item)">
              <v-list-item-title>Change Quota</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openPasswordModal(item)">
              <v-list-item-title>Change Password</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openDeleteModal(item)">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <delete-modal v-if="selectedAccount"
                  :opened="deleteModal"
                  :account="selectedAccount"
                  @account-deleted="reload"
                  @close="closeDeleteModal"></delete-modal>
    <change-password-modal v-if="selectedAccount"
                           :opened="passwordModal"
                           :account="selectedAccount"
                           @close="closePasswordModal"></change-password-modal>
    <change-quota-modal v-if="selectedAccount"
                        :opened="quotaModal"
                        :account="selectedAccount"
                        @quota-updated="reload"
                        @close="closeQuotaModal"></change-quota-modal>
    <configure-modal v-if="selectedAccount"
                     :opened="configureModal"
                     :account="selectedAccount"
                     @close="closeConfigureModal"></configure-modal>
    <change-home-path-modal v-if="selectedAccount"
                            v-model="nameModal"
                            :account="selectedAccount"
                            @updated="reload"></change-home-path-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PathInfo from './PathInfo'
import DeleteModal from './DeleteModal'
import ChangePasswordModal from './ChangePasswordModal'
import ChangeQuotaModal from './ChangeQuotaModal'
import ConfigureModal from './ConfigureModal'
import ChangeHomePathModal from './ChangeHomePathModal'

export default {
  name: 'FtpAccountsTable',
  components: {
    PathInfo,
    DeleteModal,
    ChangePasswordModal,
    ChangeQuotaModal,
    ConfigureModal,
    ChangeHomePathModal,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      search: '',
      showPopover: [],
      headers: [
        {
          text: 'Log In',
          value: 'login',
        },
        {
          text: 'Path',
          value: 'dir',
        },
        {
          text: 'Usage/Quota',
          value: '_diskused',
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ],
      deleteModal: false,
      passwordModal: false,
      quotaModal: false,
      configureModal: false,
      nameModal: false,
      selectedAccount: null,
    }
  },
  computed: mapGetters({
    ftpSubAccounts: 'ftp/ftpSubAccounts',
    pagination: 'pagination',
  }),
  methods: {
    ...mapActions(['reportError']),
    reload () {
      this.$emit('reload')
    },
    openDeleteModal (account) {
      this.selectedAccount = { ...account }
      this.deleteModal = true
    },
    closeDeleteModal () {
      this.selectedAccount = null
      this.deleteModal = false
    },
    openPasswordModal (account) {
      this.selectedAccount = { ...account }
      this.passwordModal = true
    },
    closePasswordModal () {
      this.selectedAccount = null
      this.passwordModal = false
    },
    openQuotaModal (account) {
      this.selectedAccount = { ...account }
      this.quotaModal = true
    },
    closeQuotaModal () {
      this.selectedAccount = null
      this.quotaModal = false
    },
    openConfigureModal (account) {
      this.selectedAccount = { ...account }
      this.configureModal = true
    },
    openPathModal (account) {
      this.selectedAccount = { ...account }
      this.nameModal = true
    },
    closeConfigureModal () {
      this.selectedAccount = null
      this.configureModal = false
    },
    quotaPercentage (quotaFloat) {
      return Number.parseInt(quotaFloat)
    },
  },
  created () {
    this.reload()
  },
}
</script>
